import { $t } from '@/i18n';
import wujiFetch from '@/utils/wujiFetch';
import { message } from '@utils/wuji-message';
const prefix = '/api/xy/template/component';
function getUrl(path) {
    return `${prefix}${path}`;
}
export var CompTemplateStateMode;
(function (CompTemplateStateMode) {
    CompTemplateStateMode["create"] = "create";
    CompTemplateStateMode["replace"] = "replace";
    CompTemplateStateMode["list"] = "list";
})(CompTemplateStateMode || (CompTemplateStateMode = {}));
export default {
    state: {
        mode: 'list',
        selectComponent: null,
        templateList: [],
        editableTemplates: [],
        selectComponentInfo: null,
    },
    actions: {
        /**
         * 获取组件模版列表
         */
        async fetchComponentTemplateList({ commit }, { projectId }) {
            try {
                const res = await wujiFetch(getUrl(`/list?exclude=pageInfo&projectid=${projectId}`), {
                    method: 'get',
                });
                commit('setCompTemplateState', {
                    templateList: res,
                });
                return res;
            }
            catch (err) {
                message.error($t('k_6eff55b9', { arg_0: err.message }));
            }
        },
        /**
         * 获取组件模版列表
         */
        async getComponentTemplate({}, { id }) {
            try {
                const res = await wujiFetch(getUrl(`/get/${id}`), {
                    method: 'GET',
                });
                return res;
            }
            catch (err) {
                message.error($t('k_9fe36397'));
            }
        },
        /**
         * 更新模版
         */
        async updateComponentTemplate({ commit, dispatch }, { template }) {
            try {
                await wujiFetch(getUrl('/patch'), {
                    method: 'POST',
                    body: JSON.stringify(template),
                });
                message.success($t('k_c529ef0e'));
                commit('setCompTemplateState', {
                    mode: 'list',
                });
                dispatch('fetchComponentTemplateList', { projectId: template.projectId });
                dispatch('getEditableCompTemplates');
            }
            catch (error) {
                console.error(error);
                message.error(error.message);
            }
        },
        /**
         * 创建模版
         */
        async createComponentTemplate({ dispatch }, template) {
            try {
                const res = await wujiFetch(getUrl('/create'), {
                    method: 'post',
                    body: JSON.stringify(template),
                });
                dispatch('fetchComponentTemplateList', { projectId: template.projectId });
                message.success($t('k_657c06a5'));
                return res;
            }
            catch (error) {
                message.error(error.message);
            }
        },
        /**
         * 获取当前用户有编辑全局的模板list
         */
        async getEditableCompTemplates({ commit, rootState }, { type = '', projectId } = {}) {
            try {
                const url = getUrl(`/editable?projectid=${projectId || rootState.project.projectInfo?.id}&${type ? `filter=${encodeURIComponent(`type="${type}"`)}` : ''}`);
                const res = await wujiFetch(url, {
                    method: 'GET',
                });
                commit('setCompTemplateState', {
                    editableTemplates: res,
                });
                return res;
            }
            catch (err) {
                message.error($t('k_5ca18ed8'));
            }
        },
        /**
         * 删除模版
         */
        async deleteCompTemplate({ dispatch, rootState }, { _id, projectId }) {
            try {
                await wujiFetch(getUrl('/patch'), {
                    method: 'POST',
                    body: JSON.stringify({
                        _id,
                        disabled: 1,
                    }),
                });
                message.success($t('k_686f6bd'));
                dispatch('fetchComponentTemplateList', { projectId: projectId || rootState.project.projectInfo?.id });
                dispatch('getEditableCompTemplates');
            }
            catch (error) {
                console.error(error);
                message.error($t('k_ffe59be0'));
            }
        },
        /**
         * 模版排序
         */
        async sortCompTemplate({ dispatch, rootState }, { tplSort, projectId }) {
            try {
                const validProjectId = projectId || rootState.project.projectInfo?.id;
                await wujiFetch(getUrl(`/sort/create?projectid=${validProjectId}`), {
                    method: 'post',
                    body: JSON.stringify({ tplSort }),
                });
                dispatch('fetchComponentTemplateList', { projectId: validProjectId });
            }
            catch (err) {
                throw err;
            }
        },
    },
    mutations: {
        setCompTemplateState(state, payload) {
            Object.assign(state, payload);
        },
    },
};
